"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transliterateMap = void 0;
exports.transliterateMap = {
    //   niqqud
    "\u05B0": "ǝ",
    "\u05B1": "ĕ",
    "\u05B2": "ă",
    "\u05B3": "ŏ",
    "\u05B4": "i",
    "\u05B5": "ē",
    "\u05B6": "e",
    "\u05B7": "a",
    "\u05B8": "ā",
    "\u05B9": "ō",
    "\u05BA": "ō",
    "\u05BB": "u",
    //  "\u{05BC}": "", // HEBREW POINT DAGESH OR MAPIQ (U+05BC)
    //  "\u{05BD}": "", // HEBREW POINT METEG (U+05BD)
    "\u05BE": "-",
    "\u05C7": "ο",
    //   consonants
    א: "ʾ",
    ב: "b",
    ג: "g",
    ד: "d",
    ה: "h",
    ו: "w",
    ז: "z",
    ח: "ḥ",
    ט: "ṭ",
    י: "y",
    ך: "k",
    כ: "k",
    ל: "l",
    ם: "m",
    מ: "m",
    ן: "n",
    נ: "n",
    ס: "s",
    ע: "ʿ",
    ף: "p",
    פ: "p",
    ץ: "ṣ",
    צ: "ṣ",
    ק: "q",
    ר: "r",
    ש: "š",
    ת: "t",
    "\u05EF": "",
    װ: "",
    ױ: "",
    ײ: "" // HEBREW LIGATURE YIDDISH DOUBLE YOD (U+05F2)
};
//# sourceMappingURL=hebCharsTrans.js.map